import React, { useEffect, useState } from 'react'
import TableWrapper from '../../../../component/TableWrapper';
import { Icons } from '../../../../assets';
import { useNavigate } from 'react-router-dom';
import request from '../../../../service';
import Exported from '../../../../service/endpoints';
import { useDispatch } from 'react-redux';
import { saveLoadingState } from '../../../../redux/reducers/loadingSlice';
import { Toast } from '../../../../service/toast';
import moment from 'moment';

const EnquiryList = ({ handlePageChange, searchInput, handleStatus, page, setPage, productTableList, setProductTableList, isLoading, setisLoading, sortConfig, setSortConfig, getProductList   }) => {

    const COMPLETED = 'Completed'
    const NEW_ENQUIRY = 'New'
    const IN_PROGRESS = 'In Progress'
    const dispatch = useDispatch();

    const navigate = useNavigate()

    const userHeader = [
        { label: 'Enquiry ID', sortable: 'enquiry_id' },
        { label: 'Customer Name', sortable: 'username' },
        { label: 'Customer Type', sortable: 'role' },
        { label: 'Product Type', sortable: 'product_id' },
        { label: 'Enquiry Date', sortable: 'enquiry_date' },
        { label: 'Status', sortable: 'status' },
        { label: 'Actions' },
    ];

    useEffect(() => {
        getProductList(true)
    }, [searchInput, sortConfig, page])


    const handleData = (keyValue, defaultValue, className = '') => {
        return (
            <td className={`${className}`}>{keyValue ? keyValue : defaultValue}</td>
        )
    };

    const redirectTo = (id) => {
        navigate(`?id=${id}`)
    }

    
    return (
        <>
            <div className={`eventWrapper`}>
                <div className={`mt-2 mb-5`}>
                    <TableWrapper
                        headerDetails={userHeader}
                        pageMeta={productTableList?.pageMeta}
                        handlePageChange={setPage}
                        listLength={productTableList?.result || []}
                        isLoading={isLoading}
                        sortConfig={sortConfig}
                        setSortConfig={setSortConfig}
                    >
                        {productTableList?.result?.map((item, index) => {
                            const { enquiry_id = '', user = '', product = '', enquiry_date = '', status = '', } = item;
                            const moment = require('moment');
                            const dateConvert = moment(enquiry_date, 'DD MM YYYY');
                            const formattedDate = dateConvert.format('DD MMM YYYY');
                      

                            return (
                                <tr key={enquiry_id} >
                                    {handleData(enquiry_id, '-', 'text-center')}
                                    {handleData(user.name, '-', 'text-center')}
                                    {handleData(user.role.name, '-', 'text-center')}
                                    {handleData(product?.category?.title, '-', 'text-center')}
                                    {handleData(formattedDate , '-', 'text-center')}
                                    <td className=" px-3 mx-auto text-center">
                                        <div className='' style={{
                                            color: status === 3 ? '#01CB46' :
                                                status === 1 ? '#FC0000' : status === 2 ? '#D99E27' : '#000000'
                                        }}>
                                            {status === 3 ? 'Completed' :
                                                status === 1 ? 'New' : status === 2 ? 'In Progress' : ""}
                                        </div>
                                    </td>
                                    <td className=" px-3 mx-auto text-center action-button">
                                        <div className='flex items-center justify-center'>
                                            {/* <img src={Icons.edit} alt='Edit' className='cursor-pointer w-[16px] h-[16px]' /> */}
                                            <img src={Icons.eye} alt='View' className='cursor-pointer w-[20px] h-[20px]' onClick={() => redirectTo(enquiry_id)}/>
                                            <img src={Icons.checked} alt='Done' className='cursor-pointer w-[22px] h-[22px] mx-2' style={{ opacity: status == '3' ? '0.5' : '1', pointerEvents : status == '3' ? 'none' : 'auto' }} onClick={() => status == '3' ? null  : handleStatus(enquiry_id)} />
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                    </TableWrapper>
                </div>
            </div>
        </>
    )
}

export default EnquiryList